<template>
  <div>
    <v-row>
      <v-col>
        <!-- Toolbar para volver al padre -->
        <v-toolbar v-if="categoriaSeleccionada" flat color="transparent">
          <v-btn @click="goBackOne()" icon>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <v-toolbar-title>{{ categoriaSeleccionada.name }}</v-toolbar-title>
        </v-toolbar>
        <!-- Lista principal de categorías (hasta 4) -->
        <v-sheet
          class="mx-auto"
          max-width="700"
          v-if="categoriasInternas.length > 0"
        >
          <v-slide-group show-arrows>
            <v-slide-item
              v-for="categoria in categoriasMostradas"
              :key="categoria.id"
              :value="categoria.id"
            >
              <v-btn
                class="mx-2"
                depressed
                rounded
                @click="seleccionarCategoria(categoria)"
              >
                {{ categoria.name }}
              </v-btn>
            </v-slide-item>

            <v-slide-item v-show="categoriasInternas.length > 5">
              <v-btn class="mx-2" depressed rounded @click="dialog = true">
                +{{ categoriasInternas.length - 5 }}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Dialog con todas las categorías y buscador -->
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          Buscar categoría
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            outlined
            v-model="busqueda"
            label="Buscar..."
            clearable
          ></v-text-field>
          <v-container>
            <v-row v-if="categoriasSeleccionadas.length > 1">
              <v-col>
                <div class="display-1">
                  <v-icon large left @click="goBackOne">mdi-arrow-left</v-icon
                  >{{ categoriasSeleccionadas.at(-1).name }}
                </div>
                <div
                  id="navigation"
                  v-show="categoriasSeleccionadas.length > 2"
                >
                  <ul>
                    <li
                      @click="quitBreadCrumbCategoria(cat)"
                      v-for="cat in categoriasSeleccionadas"
                      :key="cat.id"
                    >
                      <a>
                        <span class="ml-1">{{ cat.name }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                v-for="categoria in categoriasFiltradas"
                :key="categoria.id"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card
                  height="100%"
                  outlined
                  @click="seleccionarCategoria(categoria)"
                >
                  <v-card-text>{{ categoria.name }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CategoriasAPI from "@/api/categorias";

export default {
  name: "ProductoCategoriaSelect",
  props: {
    uso: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      categoriasInternas: [],
      categoriaSeleccionada: null,
      categoriasSeleccionadas: [
        {
          id: 0,
          name: "Categorías",
        },
      ],
      categoriaPadre: null,
      dialog: false,
      busqueda: "",
    };
  },
  computed: {
    categoriasMostradas() {
      return this.categoriasInternas.slice(0, 5);
    },
    categoriasFiltradas() {
      if (!this.busqueda) return this.categoriasInternas;
      return this.categoriasInternas.filter((cat) =>
        cat.name.toLowerCase().includes(this.busqueda.toLowerCase())
      );
    },
  },
  created() {
    this.fetchCategoriaPadre();
  },
  methods: {
    fetchCategoriaPadre() {
      CategoriasAPI.index(null, null, false, this.uso).then((response) => {
        this.categoriaPadre = response.data.parent;
        this.categoriasInternas = response.data.parent.children;
        this.categoriaSeleccionada = null;
      });
    },
    deseleccionarCategoria() {
      this.categoriaSeleccionada = null;
      this.$emit("categoria-seleccionada", null); // evento para padre
      this.fetchCategoriaPadre();
    },
    async retrocederCategoria(cat) {
      const len = this.categoriasSeleccionadas.length;

      // Si no se pasa cat, usamos la última categoría seleccionada
      if (!cat) {
        cat = this.categoriasSeleccionadas[len - 1];
      }

      // Encontrar el índice actual en el array
      const catIndex = this.categoriasSeleccionadas.indexOf(cat);

      if (catIndex === -1) {
        // La categoría no está en el array, retrocedemos a la última
        cat = this.categoriasSeleccionadas[len - 1];
      } else if (catIndex > 0) {
        // Retrocedemos a la categoría anterior
        cat = this.categoriasSeleccionadas[catIndex - 1];
      } else {
        // Si estamos en la primera categoría, quedamos en la raíz
        cat = this.categoriasSeleccionadas[0];
      }


      // Mantener la cadena hasta la categoría retrocedida
      const newIndex = this.categoriasSeleccionadas.indexOf(cat);
      this.categoriasSeleccionadas.splice(newIndex + 1);

      if (cat.name === "Categorías") {
        this.fetchCategoriaPadre(cat);
      } else {
        await this.fetchCategoria(cat);
        this.$emit("categoria-seleccionada", cat);
      }
    },

    // Wrapper para el botón “volver”
    goBackOne() {
      this.retrocederCategoria(null, true);
    },

    // Wrapper para el breadcrumb
    quitBreadCrumbCategoria(cat) {
      this.retrocederCategoria(cat, false);
    },

    async fetchCategoria(categoria) {
      try {
        const response = await CategoriasAPI.index(categoria.name, null, false, this.uso);
        console.log(response.data);

        if (response.data.parent && response.data.parent.tiene_hijos) {
          this.categoriasInternas = response.data.parent.children;
          this.categoriaPadre = categoria;
          this.categoriaSeleccionada = categoria;
          this.dialog = false;
        }
      } catch (error) {
        console.error("Error cargando subcategorías:", error);
      }
    },
    seleccionarCategoria(categoria) {
      this.categoriaSeleccionada = categoria;
      this.$emit("categoria-seleccionada", categoria);

      // Si tiene children, recargar la lista con la categoría seleccionada
      this.categoriasSeleccionadas.push(categoria);

      if (categoria.tiene_hijos) {
        this.fetchCategoria(categoria);
      } else {
        this.categoriasInternas = [];
        this.dialog = false;
      }
    },
  },
};
</script>

<style scoped>
.v-slide-group {
  margin-top: 10px;
}
#navigation ul {
  margin: 1px auto 0 auto;
  height: 50px;
  padding: 0;
  float: relative;
}

#navigation ul li {
  position: relative;
  list-style-type: none;
  display: inline;
}

#navigation li:before {
  content: "  > ";
}

#navigation li:first-child:before {
  content: none;
}
#navigation li:last-child a {
  color: grey;
  pointer-events: none;
}
</style>
